import { Injectable } from '@angular/core';
import { getCurrentAuthenticatedUser } from '@tmx/auth';

import { WindowWithSalesforce } from '../models/window-with-salesforce';

@Injectable({
  providedIn: 'root',
})
export class SalesforceChatService {
  private isLoaded = false;
  private isInitialized = false;
  private shouldAutoLaunch = false;
  private prechatDataCache: null | Record<string, unknown> = null;
  private readonly windowWithSalesforce = window as WindowWithSalesforce;

  loadAndInitialize() {
    if (this.isLoaded) {
      return;
    }

    this.isLoaded = true;

    window.addEventListener('onEmbeddedMessagingReady', () => {
      this.setupPrechatFields();
    });

    window.addEventListener('onEmbeddedMessagingButtonCreated', () => {
      if (this.shouldAutoLaunch) {
        this.shouldAutoLaunch = false;
        setTimeout(() => {
          this.launchChat();
        }, 100);
      }
    });

    this.setupPrechatDataCaching();
    this.setupConversationGreeting();

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src =
      'https://crmtransportation--uat.sandbox.my.site.com/ESWUATChat1754420416962/assets/js/bootstrap.min.js';
    script.onload = () => this.initializeEmbeddedMessaging();

    document.head.appendChild(script);
  }

  setShouldAutoLaunch(shouldLaunch: boolean) {
    this.shouldAutoLaunch = shouldLaunch;
    const embeddedService = this.windowWithSalesforce.embeddedservice_bootstrap;

    if (shouldLaunch && embeddedService?.utilAPI?.launchChat) {
      setTimeout(() => {
        this.launchChat();
        this.shouldAutoLaunch = false;
      }, 100);
    }
  }

  launchChat() {
    const embeddedService = this.windowWithSalesforce.embeddedservice_bootstrap;
    if (embeddedService?.utilAPI?.launchChat) {
      embeddedService.utilAPI.launchChat();
    }
  }

  private setupPrechatFields() {
    if (
      this.windowWithSalesforce.embeddedservice_bootstrap?.prechatAPI
        ?.setVisiblePrechatFields
    ) {
      const currentUser = getCurrentAuthenticatedUser();

      this.windowWithSalesforce.embeddedservice_bootstrap.prechatAPI.setVisiblePrechatFields(
        {
          _email: {
            isEditableByEndUser: false,
            value: currentUser.username,
          },
          'Product Family': {
            isEditableByEndUser: false,
            value: 'CoPilot Enterprise',
          },
          Module: {
            isEditableByEndUser: false,
            value: 'Account Manager',
          },
        }
      );
    }
  }

  private setupPrechatDataCaching() {
    window.addEventListener('onEmbeddedMessagingPreChatSubmitted', (event) => {
      this.prechatDataCache = (
        event as CustomEvent<{ prechatSubmitFields: Record<string, unknown> }>
      ).detail.prechatSubmitFields;
    });
  }

  private setupConversationGreeting() {
    window.addEventListener('onEmbeddedMessagingConversationOpened', () => {
      if (!this.prechatDataCache) {
        console.warn('No pre-chat data cached yet. Delaying greeting.');
        return;
      }

      const descValue = this.prechatDataCache['Description'];
      const subValue = this.prechatDataCache['_subject'];
      const desc = typeof descValue === 'string' ? descValue : '';
      const sub = typeof subValue === 'string' ? subValue : '';
      const prechatData = `SUBJECT :${sub}\nDESCRIPTION : ${desc}\n`;

      this.windowWithSalesforce.embeddedservice_bootstrap?.utilAPI?.sendTextMessage(
        prechatData
      );
    });
  }

  private initializeEmbeddedMessaging() {
    if (
      this.isInitialized ||
      !this.windowWithSalesforce.embeddedservice_bootstrap
    ) {
      return;
    }

    this.isInitialized = true;

    this.windowWithSalesforce.embeddedservice_bootstrap.settings.language =
      'en_US';
    this.windowWithSalesforce.embeddedservice_bootstrap.settings.displayHelpButton = false;

    this.windowWithSalesforce.embeddedservice_bootstrap.init(
      '00DRL00000CSIZV',
      'UAT_Chat',
      'https://crmtransportation--uat.sandbox.my.site.com/ESWUATChat1754420416962',
      {
        scrt2URL:
          'https://crmtransportation--uat.sandbox.my.salesforce-scrt.com',
      }
    );
  }
}
